export const CALENDAR_ITEM_REGISTRATION_STATUS_ID_INVITED = 1
export const CALENDAR_ITEM_REGISTRATION_STATUS_KEY_INVITED = 'calendar_item_user_registration_status_invited'

export const CALENDAR_ITEM_REGISTRATION_STATUS_ID_YES = 2
export const CALENDAR_ITEM_REGISTRATION_STATUS_KEY_YES = 'calendar_item_user_registration_status_yes'

export const CALENDAR_ITEM_REGISTRATION_STATUS_ID_BACKUP = 3
export const CALENDAR_ITEM_REGISTRATION_STATUS_KEY_BACKUP = 'calendar_item_user_registration_status_backup'

export const CALENDAR_ITEM_REGISTRATION_STATUS_ID_NO = 4
export const CALENDAR_ITEM_REGISTRATION_STATUS_KEY_NO = 'calendar_item_user_registration_status_no'
